import { AnchorHTMLAttributes, ReactElement, ReactNode } from "react";
import { AUTHENTICATION_STORED_ITEM, authenticationFlag } from "../../shared/utils/authentication-item.utils";
import { useStoredItem } from "../../state/InternalContext";
import { useAuth } from "../internal/AuthProvider";
import { AuthActionAnchor } from "./auth-action-anchor";

interface ChangePasswordButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    children?: ReactNode;
}

/**
 * Opens the change-password dialog for every signed-in user.
 * Themes that should hide it for Azure or Google compare `canChangePassword` themselves.
 */
export function ChangePasswordButton({ children, ...anchorProps }: ChangePasswordButtonProps): ReactElement | null {
    const item = useStoredItem(AUTHENTICATION_STORED_ITEM);
    const { showChangePassword } = useAuth();

    if (!authenticationFlag(item, "showLogout")) {
        return null;
    }

    return (
        <AuthActionAnchor
            {...anchorProps}
            defaultLabel="Change Password"
            title="Change Password"
            onAction={showChangePassword}
        >
            {children}
        </AuthActionAnchor>
    );
}
